export default "__VITE_ASSET___GrdkK9L__"